import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ApproveFourForm from "./dynamic-form/ApproveFourForm";
import ApproveFourElement from "./dynamic-report/ApproveFourElement";

class ReportApproveFour extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get showReviewed() {
    return this.props.report.approvedFourAt;
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        {this.props.report.getCanApproveFour(this.props.userContext.scope) &&
        <ApproveFourForm reportGuid={this.props.report.guid}/>
        }
        {this.showReviewed &&
        <ApproveFourElement
          approvedFourAt={this.props.report.approvedFourAt}
          approvedFourBy={this.props.report.getFullNameFor('approverFour')}
          approveCommentFour={this.props.report.approveCommentFour}
        />
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps, null)(ReportApproveFour);
